import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'shortenFullName',
    standalone: false
})
export class ShortenFullNamePipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return '';
        }

        const parts = value.trim().split(/\s+/);
        if (parts.length < 1) {
            return '';
        }

        const lastName = parts[0];
        const firstInitial = parts[1] ? parts[1][0] + '.' : '';
        const middleInitial = parts[2] ? parts[2][0] + '.' : '';

        return `${lastName} ${firstInitial}${middleInitial}`.trim();
    }
}
